import { Address as ox__Address } from 'ox'

import { Address, Formatted } from '~/utils/address/types'

export type Type = Address<`0x${string}`, 'evm'>

export function validate(str: string): str is Type {
  return ox__Address.validate(str)
}

export function format(str: string): Formatted<Type> {
  return ox__Address.from(str, { checksum: true }) as Formatted<Type>
}
